export enum CertificateHistoryTableColumn {
  NOMBRE = 'nombre',
  EMISION = 'emision',
  ESTATUS = 'estatus',
  FECHA_CREACION = 'fechacreacion',
  EMPTY = '',
}
